import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation files
import translationTR from './locales/tr.json';
import translationEN from './locales/en.json';
import translationAR from './locales/ar.json';

// Resources
const resources = {
  tr: {
    translation: translationTR
  },
  en: {
    translation: translationEN
  },
  ar: {
    translation: translationAR
  }
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    resources,
    fallbackLng: 'tr', // Default language
    lng: localStorage.getItem('language') || 'tr', // Get from localStorage or default to TR
    debug: false,

    // Eksik çeviri key'lerini konsola yazdır
    saveMissing: true,
    missingKeyHandler: (lngs, ns, key) => {
      console.warn(`🌐 Eksik çeviri: "${key}" [${lngs}]`);
    },

    interpolation: {
      escapeValue: false // React already escapes
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

// Helper function to get text direction (LTR or RTL)
export const getDirection = (language) => {
  const rtlLanguages = ['ar', 'he', 'fa', 'ur']; // Arabic, Hebrew, Persian, Urdu
  return rtlLanguages.includes(language) ? 'rtl' : 'ltr';
};

// Helper function to check if language is RTL
export const isRTL = (language) => {
  return getDirection(language) === 'rtl';
};

// Apply direction and lang attribute to document based on current language
const applyLanguageDirection = (language) => {
  const dir = getDirection(language);
  document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', language);
};

// Apply on init
applyLanguageDirection(i18n.language);

// Apply on language change
i18n.on('languageChanged', (lng) => {
  applyLanguageDirection(lng);
  localStorage.setItem('language', lng);
});

export default i18n;
